<template>
    <el-drawer
        :title="`${item.id?'编辑':'新增'}内容`"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="800px"
        :before-close="close">
        <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="标题">
                <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="类型">
                <el-select v-model="form.typeId" clearable  placeholder="全部">
                    <el-option
                        v-for="item in typeOption"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="标签">
                    <el-input v-model="form.tags" placeholder="多个标签用 ，隔开"></el-input>
                </el-form-item>
            <el-form-item label="内容">
                <div class="panel fx-g1">
                    <vue-neditor-wrap v-model="form.content" :config="myConfig" :destroy="false" ></vue-neditor-wrap>
                </div>
            </el-form-item>
            <el-form-item label="优先显示">
                  <el-checkbox v-model="form.enable"></el-checkbox>
            </el-form-item>
            <div class="panel fx-g1 fx-c_stretch" v-loading="uploading" element-loading-text="上传中...">
                <div>
                    <div class="fx fx-center fx-g1 font18 text_primary upload_btn" @click="$refs.uploadFile.click()">
                        <i class="font22 iconfont icon-yunshangchuan"></i> 从本地上传照片
                        <input type="file" ref="uploadFile" class="hide" accept="image/*" @change="upload($event)">
                    </div>
                </div>
                <div class="fx-g1 fx fx-wrap fx-m_between fx-c_start" style="padding: 20px">

                    <div v-for="(item, i) in form.list" :key="i" class="pic_item">
                        <img :src="form.id > 0 ? item.url:item" alt="">
                        <i class="iconfont icon-notpass del_btn" @click="delPic(i)"></i>
                    </div>


                </div>
            </div>
            <span  class="fx fx-center">
                <el-button type="primary" @click="sub()">确 定</el-button>
                <el-button @click="close()">关 闭</el-button>
            </span>
        </el-form>

    </el-drawer>

</template>


<style scoped>
    .fx-c_stretch .pic_item {
        width: 40%;
        height: 200px;
        border-radius: 10px;
        overflow: hidden;
        margin-bottom: 30px;
        position: relative;
    }
    .pic_item img {
        width: 100%;
        height: 100%;
    }

    /* .bottom {
        height: 80px;
    }
    .bottom > * {
        margin: 0 20px;
    } */
    .fx-c_stretch .del_btn {
        display: inline-block;
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        font-size: 30px;
        color: rgb(22, 21, 21);
    }
    .del_btn:hover {
        color: var(--primary);
    }
    .upload_btn {
        border: 1px dashed var(--primary);
        border-radius: 10px;
        cursor: pointer;
    }
</style>
<script>

    import VueNeditorWrap from 'vue-neditor-wrap'

    export default {
        props: [
            "item",
        ],
        components: {
            VueNeditorWrap
        },
        data() {
            return {
                show: false,
                uploading: false,
                form: {...this.item,list:[]},
                typeOption: {},
                needRefreshParent: false,
                myConfig: {
                    // 如果需要上传功能,找后端小伙伴要服务器接口地址
                    serverUrl: '/api/web/upload/ueditor',
                    UEDITOR_HOME_URL: '/admin/NEditor/',
                    // 编辑器不自动被内容撑高
                    autoHeightEnabled: false,
                    // 初始容器高度
                    initialFrameHeight: 400,
                    // 初始容器宽度
                    initialFrameWidth: '100%',
                    // 关闭自动保存
                    enableAutoSave: true,
                    maximumWords:2000
                },
            }

        },


        methods: {
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {
                    this.$emit("close");
                }
            },
            sub() {
                if (this.form.title == "") {
                   this.$showError("请输入标题再保存");
                   return;
                }
                if (this.form.typeId == "") {
                   this.$showError("请选择类型再保存");
                   return;
                }
                if (this.form.content == "") {
                   this.$showError("请输入内容再保存");
                   return;
                }
                let newList = [];
                if(this.form.id > 0){
                    this.form.list.forEach(item =>{
                        newList.push(item.url);
                    })
                }
                this.$ajaxPost("/article/save", {
                    article: this.form,
                    urls: this.form.id > 0? newList:this.form.list
                }, data => {
                    this.$showSuccess("保存成功", 1200, ()=> {
                        this.needRefreshParent = true;
                        this.$emit("submit", data.result);
                        this.$emit("close");
                    })
                })
            },
            loadType() {
                this.$ajaxGet("/articleType/listArticleType", (data) => {
                    this.typeOption = data.result;
                })
            },
            upload(e) {
                if (e.target.value) {
                    this.uploading = true;
                    let file = e.target.files[0];
                    this.$uploadQiniu(file, "article/", {
                            success: (file) => {
                                this.form.list.push(this.form.id > 0 ? {url:file.url} : file.url);
                                this.uploading = false;
                            }
                        }
                    )
                }
            },
            delPic(index) {
                if(this.form.id > 0 && this.form.list[index].id){
                    console.log(this.form.list[index].id)
                    this.$showConfirm("确认删除该图吗?", ()=> {
                        this.$ajaxGet("/mediaResource/del/" + this.form.list[index].id, (data) => {
                            this.form.list.splice(index,  1);
                            this.form.resources.splice(index,  1);
                        })
                    })
                    return;
                }
                this.$showConfirm("确认删除该图吗", ()=> {
                    this.form.list.splice(index,  1);
                })
            },

        },
        mounted() {
            this.show = true;
        },
        created() {
            this.form.list = [];
            if(this.form.id > 0){//修改赋值到form.list
                this.form.list = this.form.resources;
            }
            if(this.form.id == undefined){//新增 内容清空
                this.form.content = "";
            }
            this.loadType();
        }


    }
</script>
